import { useState } from 'react';
import { Badge } from './badges';
import type { TrueFalseFixture } from '../../../mock/practice';

const choiceBtn = {
  flex: 1,
  height: 44,
  borderRadius: 'var(--radius-control)',
  background: 'var(--surface-tint)',
  border: '1px solid var(--border-default)',
  color: 'var(--ink)',
  cursor: 'pointer',
  fontFamily: 'var(--font-vi)',
  fontWeight: 600,
  fontSize: 15,
} as const;

/** UI Đúng/Sai chạy trên fixture (DB có 0 bản ghi TRUE_FALSE) — xem src/mock/practice.ts. */
export function TrueFalseExercise({ data }: { data: TrueFalseFixture[] }) {
  const [answers, setAnswers] = useState<Record<number, boolean>>({});

  const answer = (order: number, value: boolean) => {
    if (order in answers) return;
    setAnswers({ ...answers, [order]: value });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <Badge tone="warning">Dữ liệu mẫu</Badge>
        <Badge tone="info">Đúng / Sai</Badge>
      </div>
      <div style={{ fontSize: 12.5, color: 'var(--text-secondary)' }}>Bản dịch tiếng Việt có khớp câu tiếng Nhật không?</div>
      {data.length === 0 ? (
        <div style={{ fontSize: 14, color: 'var(--text-secondary)' }}>Chưa có câu nào.</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {data.map((item) => {
            const answered = item.order in answers;
            const isCorrect = answered && answers[item.order] === item.isTrue;
            return (
              <div key={item.order} style={{ border: '1px solid var(--border-default)', borderRadius: 'var(--radius-card)', padding: 16, display: 'flex', flexDirection: 'column', gap: 12 }}>
                <div style={{ fontFamily: 'var(--font-jp)', fontSize: 19, color: 'var(--ink)' }}>{item.statementJp}</div>
                <div style={{ fontSize: 16, color: 'var(--ink)' }}>{item.claimVi}</div>
                {!answered ? (
                  <div style={{ display: 'flex', gap: 12 }}>
                    <button onClick={() => answer(item.order, true)} style={choiceBtn}>
                      Đúng
                    </button>
                    <button onClick={() => answer(item.order, false)} style={choiceBtn}>
                      Sai
                    </button>
                  </div>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    <div
                      style={{
                        alignSelf: 'flex-start',
                        background: isCorrect ? 'var(--success)' : 'var(--error)',
                        color: '#fff',
                        borderRadius: 999,
                        padding: '8px 16px',
                        fontSize: 13,
                        fontWeight: 600,
                      }}
                    >
                      {isCorrect ? 'Đúng rồi!' : 'Chưa đúng'}
                    </div>
                    <div style={{ background: 'var(--surface-section)', borderRadius: 'var(--radius-card)', padding: 16 }}>
                      <div style={{ fontSize: 14, color: 'var(--ink)', lineHeight: 1.5 }}>{item.explainVi}</div>
                      <div style={{ fontSize: 14, color: 'var(--text-secondary)', marginTop: 4 }}>{`Đáp án: ${item.isTrue ? 'Đúng' : 'Sai'}`}</div>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
